import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthControllerService, User} from "../api";

@Injectable({
  providedIn: 'root'
})
export class UserResolver  {
  private authControllerService = inject(AuthControllerService);


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
    return this.authControllerService.profile();
  }
}
